import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@mui/material";
import { useCategoryResponsiveName } from "../posts/Photos/GalleryCarousel";
import { textFieldStyle } from "../../../assets/styles/styles";
import { globalAppConfigStore } from "../../../stores/appConfig/globalAppConfigStore";
export const CategoryChip = ({ category, onClick }) => {
    const props = globalAppConfigStore.useComponent('theme')?.params?.components?.CategoryChip || {};
    props.sx = { ...textFieldStyle, backgroundColor: '#ffffff33', ...(props.sx || {}) };
    return (_jsx(Chip, { label: useCategoryResponsiveName(category), onClick: onClick, ...props }, category.id));
};
//# sourceMappingURL=CategoryChip.js.map